interface Props {
  activeColor: string;
  bgColor?: string;
}

const HotLeadsIcon = ({ activeColor, bgColor }: Props) => {
  const fillColor = activeColor ? activeColor : "#2E8B57";
  const bgFillColor = bgColor ? bgColor : "#d0f5e8";
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill={bgFillColor} />

      <path
        d="M14 28 L20 22 L25 26 L34 17"
        stroke="#2E8B57"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M30 17 H34 V21"
        stroke="#2E8B57"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HotLeadsIcon;
